import React, { useState, useContext } from "react"
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Box,
  Typography,
} from "@material-ui/core"
import MenuIcon from "@material-ui/icons/Menu"
import {
  makeStyles,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles"
import { CartContext, SetTheme } from "./Context"
import { theme as t } from "../config"
import { Theme } from "./Context"
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart"
import NotInterestedIcon from "@material-ui/icons/NotInterested"
import InvertColorsIcon from "@material-ui/icons/InvertColors"
import InfoIcon from "@material-ui/icons/InfoOutlined"
import Modal from "../widgets/Modal"
import Alert from "../widgets/Alert"
import Form from "./Form"
import Info from "./Info"
const useStyles = makeStyles({
  AppBar: {
    top: "auto",
    bottom: 0,

    "& 	.Mui-disabled": {
      backgroundColor: "rgba(0,0,0,0.4)",
      pointerEvents: "auto",
      "&:hover": {
        background: "auto",
        backgroundColor: "rgba(0,0,0,0.4)",
        border: "none",
        boxShadow: "none",
        opacity: 1,
      },
    },
  },
  ContainerActions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  Perfil: {
    width: 100,
    height: 60,
    "& img": {
      border: props => `2px solid ${props.turquesa}`,
      width: 60,
      borderRadius: "50%",
      position: "absolute",
      bottom: 8,
      left: 14,
    },
  },
  Button: {
    maxWidth: 300,
    "@media (max-width:340px)": {
      fontSize: "0.6em",
    },
  },
  IconButton: {
    // background: `${color.gray} !important`,
    // position: "absolute",
    // bottom: 14,
    // right: 14,
  },
})

const Menu = ({ logo, title }) => {
  const color = t(useContext(Theme))
  const theme = createMuiTheme({
    palette: {
      type: useContext(Theme),
      primary: { main: color.gray },
    },
  })
  const classes = useStyles(color)
  const { cart } = useContext(CartContext)
  const setTheme = useContext(SetTheme)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [openModalInfo, setOpenModalInfo] = useState(false)
  const [error, setError] = useState(false)
  let lenghtProducts = 0
  try {
    lenghtProducts = cart.products.length
  } catch (error) {
    console.error(
      "Menu: Ocurrió un error al calcular la cantidad de productos de cartContext"
    )
  }
  return (
    <AppBar position="fixed" className={classes.AppBar}>
      <ThemeProvider theme={theme}>
        <Toolbar>
          <Box className={classes.ContainerActions}>
            <div className={classes.Perfil}>
              <img src={logo} alt={`logo de ${title}`} />
            </div>
            <Button
              fullWidth
              className={`${classes.Button} ${
                lenghtProducts === 0 ? "Mui-disabled" : ""
              }`}
              color="secondary"
              variant="contained"
              onClick={
                lenghtProducts !== 0
                  ? () => setOpenModalForm(true)
                  : () => setError(true)
              }
            >
              {lenghtProducts !== 0 ? (
                <ShoppingCartIcon />
              ) : (
                <>
                  <NotInterestedIcon />
                </>
              )}
              Finalizar compra
            </Button>
            {/* <IconButton
              onClick={() => setOpenModalInfo(true)}
              className={classes.IconButton}
              color="primary"
            >
              <InfoIcon></InfoIcon>
            </IconButton> */}
            <IconButton
              onClick={setTheme}
              className={classes.IconButton}
              color="primary"
            >
              <InvertColorsIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </ThemeProvider>
      <Modal open={openModalForm} onClose={() => setOpenModalForm(false)}>
        <Form></Form>
      </Modal>
      <Modal open={openModalInfo} onClose={() => setOpenModalInfo(false)}>
        <Info></Info>
      </Modal>
      <Alert
        open={error}
        onClose={() => setError(false)}
        message="Agrega al menos un producto"
      />
      <style jsx="true" global="true">
        {`
          body {
            margin-bottom: 100px;
          }
        `}
      </style>
    </AppBar>
  )
}

export default Menu
